export default __webpack_public_path__ + "static/media/EPQL.549a026d.png";